/** Versão do cache PWA — manter alinhada com `frontend/sw.js` (`CACHE_VERSION`). */
export const PWA_CACHE_VERSION = 'petrohouse-v106';
